'use client'

import * as React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

/**
 * TranslationDetailsSkeleton component for displaying loading state
 */
export function TranslationDetailsSkeleton() {
	return (
		<div className="bg-background min-h-screen">
			<div className="flex flex-col space-y-4 sm:space-y-6">
				{/* Header skeleton */}
				<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
					<div className="flex items-center gap-4">
						<Skeleton height={40} width={40} borderRadius="0.375rem" />
						<div>
							<Skeleton height={32} width={200} />
							<Skeleton height={20} width={300} className="mt-2" />
						</div>
					</div>
					<div className="flex gap-2">
						<Skeleton height={36} width={80} borderRadius="0.375rem" />
						<Skeleton height={36} width={100} borderRadius="0.375rem" />
					</div>
				</div>

				{/* Form skeleton */}
				<div className="mt-6 space-y-6">
					<Skeleton height={200} width="100%" borderRadius="0.5rem" />
					<Skeleton height={400} width="100%" borderRadius="0.5rem" />
				</div>
			</div>
		</div>
	)
}

